<form class="document-wrapper" [formGroup]="form" [ngClass]="{ 'is-modal': isModal }">
  <p>{{ document.code }}</p>
  <p class="document-notes">{{ document.notes || '-' }}</p>
  @if (isEditMode) {
    <div class="textarea-wrapper">
      <textarea
        class="form-control lna"
        id="backofficeNotes"
        [ngClass]="{ invalid: this.shouldRenderError('backofficeNotes') }"
        type="text"
        formControlName="backofficeNotes"
        name="backofficeNotes"
        maxlength="{{ maxFieldLength }}"></textarea>
      <p class="length" [ngClass]="{ invalid: backofficeNotes?.value?.length > maxFieldLength }">
        {{ backofficeNotes?.value?.length || 0 }}/{{ maxFieldLength }}
      </p>
      @if (getErrorMessage('backofficeNotes'); as errorMessage) {
        <div class="error-wrapper">
          <small class="error-message">
            {{ errorMessage | translate }}
          </small>
        </div>
      }
    </div>
  } @else {
    <p class="document-lna-notes">{{ document.backofficeNotes || '-' }}</p>
  }
  @if (!isModal) {
    <div class="actions">
      @if (!isEditMode) {
        <button class="action-link" (click)="isEditMode = true">
          <img src="assets/images/edit-icon.svg" alt="edit" />
          {{ 'pages.service.visitRoom.edit' | translate }}
        </button>
      } @else {
        <button class="primary" (click)="updateNotes()">
          {{ 'pages.service.visitRoom.save' | translate }}
        </button>
        <button class="secondary" (click)="isEditMode = false">
          {{ 'pages.service.visitRoom.cancel' | translate }}
        </button>
      }
    </div>
  }
</form>
